import GlobalMenuButton from './global-menu-button';
import CamContextSwitcher from '../cam-context-switcher/scripts/cam-context-switcher';
import CamContextSwitcherPanel from '../cam-context-switcher/scripts/cam-context-switcher-panel';
import { eventContextChanged } from '../cam-context-switcher/scripts/cam-context-switcher-constants';
import '../cam-context-switcher/styles/main.less';

export default class GlobalContextSwitcherButton extends GlobalMenuButton {

  render(template, defaultOptions) {
    super.render(template, defaultOptions);

    let titleElement = this.element.querySelector('.dt-gnm-menu-button__title');
    titleElement.textContent = 'Workspace';
    let subtitleElement = this.element.querySelector('.dt-gnm-menu-button__current_option');
    subtitleElement.classList.add('context-switcher');
    let camContextSwitcher = new CamContextSwitcher();
    camContextSwitcher.selectedWorkspaceId = this.selectedWorkspaceId;
    subtitleElement.appendChild(camContextSwitcher);
  }

  observe() {
    super.observe();
    document.addEventListener(eventContextChanged, this.close.bind(this));
  }

  destroy() {
    super.destroy();
    document.removeEventListener(eventContextChanged, this.close.bind(this));
  }

  get cssClass() {
    return 'global-context-switcher';
  }

  get menuItems() {
    return [
      new CamContextSwitcherPanel()
    ];
  }

}



// WEBPACK FOOTER //
// ./src/scripts/global-context-switcher-button.js